import { Component, EventEmitter, OnInit, Output,  } from "@angular/core";

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { LeadService } from "app/platform/lead/lead.service";
import { LoaderService } from "app/services/loader.service";
import { CategoryService } from "../category.service";
import { environment } from "environments/environment";
declare var $: any;
import * as _moment from "moment";
const moment = (_moment as any).default ? (_moment as any).default : _moment;

@Component({
  selector: "app-bulk-po",
  templateUrl: "./bulk-po.component.html",
  styleUrls: ["./bulk-po.component.css"],
  providers: [CategoryService],
})
export class BulkPoComponent implements OnInit {
  selectedTab = "maintenance_po";
  activeTab = "Maintenance PO";
  from_date: any;
  to_date: any;
  data: any;
  uploadInvoiceForm: FormGroup;
  milestoneeditForm: FormGroup;
  public todayDate: any = new Date();
  errorMessage: string;
  successMessage: string;
  msgError: boolean = false;
  successError: boolean = false;
  per_page: any;
  current_page: any;
  total_page: any;
  isLoaded: boolean = false;
  invoice_err_msg: string;
  invoiceType = "normal";
  invoice_date: any;
  paymentTerm;
  line_item_in_po;
  current_expected_delivery_date: any;
  podetails: any;
  current_user: any;
  eddIndex: any;
  role: string;
  dateType:any;

  constructor(
    private formBuilder: FormBuilder,
    private CategoryService: CategoryService,
    private LoaderService: LoaderService
  ) {}

  ngOnInit() {
    this.role = localStorage.getItem("user");
    this.selectedTab = "maintenance_po";
    this.activeTab = "Maintenance PO";
    this.milestoneeditForm = this.formBuilder.group({
      current_expected_delivery_date: new FormControl("", Validators.required),
    });
    this.uploadInvoiceForm = this.formBuilder.group({
      tax_invoice: [false, Validators.required],
      invoice_date: [new Date(), Validators.required],
      invoice_number: ["", Validators.required],
      invoice_amount: ["", Validators.required],
      tax_amount: [0],
    });

    this.getItems("");
    this.getcountretail();
    this.current_user = localStorage.getItem("user");
    this.date_type ="edd";
  }
  countretail: any;
  getcountretail() {
    this.CategoryService.getcountpos().subscribe((res) => {
      this.countretail = res.retail_po;
    });
  }
  activateTab(tab) {
    this.selectedTab = tab;
    switch (tab) {
      case "retail_po":
        this.activeTab = "Retail Po";
        break;
      case "maintenance_po":
        this.activeTab = "Maintenance PO";
        break;
    }
  }
  searchstring: any;
  final_from_date: any;
  final_to_date: any;
  headers_res: any;
  purchase_orders: any;
  getItems(e) {
    if (e !== undefined && e !== "") {
      this.current_page = e;
    }
    if (this.status == undefined) {
      this.status = "";
    }
    if (this.current_page == undefined) {
      this.current_page = 1;
    }

    if (this.searchstring == undefined) {
      this.searchstring = "";
    }
    if (this.final_from_date == undefined) {
      this.final_from_date = "";
    }
    if (this.final_to_date == undefined) {
      this.final_to_date = "";
    }
    this.dateType = this.date_type;
    if (this.dateType == undefined) {
      this.dateType = "edd";
    }
    this.LoaderService.display(true);

    this.CategoryService.getListPObulk(
      this.searchstring,
      this.final_from_date,
      this.final_to_date,
      this.current_page,
      this.status,
      this.dateType
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.headers_res = res.headers._headers;
        this.per_page = this.headers_res.get("x-per-page");
        this.total_page = this.headers_res.get("x-total");
        this.current_page = this.headers_res.get("x-page");
        if (res.status == 204) {
          this.purchase_orders = [];
          this.podetails.total_pos = 0;
          this.podetails.total_po_amount = 0;
          this.msgError = true;
          this.errorMessage = "No Purchase orders Data Found";
          setTimeout(
            function () {
              this.msgError = false;
            }.bind(this),
            7000
          );
        }
        res = res.json();
        this.purchase_orders = res.po_wip_orders;
        this.podetails = res;
      },
      (err) => {
        this.LoaderService.display(false);
      }
    );
  }

  selectedrow: any;
  row = [""];
  toggleRow(po, i) {
    if (this.row[0] !== po.id) {
      this.expansion = po.id;
      this.row[0] = po.id;
    } else {
      this.row[0] = "";
      this.expansion = "";
    }
  }
  sliitems = [];
  edit_po_id: any;
  ListOfinvoices: any;
  getslidetails(po) {
    this.edit_po_id = po.id;
    this.purchase_order_id = po.id;
    this.payment_tem_days = po.payment_term;
    this.invoice_remaining_amt = po.bulk_invoice_remaining_total_amount;
    $("#Invoice").prop("checked", false);
    this.basefile = "";
    this.file_name = "";
    this.invoice_check = false;
  }
  editsPO(po, i) {
    this.eddIndex = i;
    let edd = po.initial_expected_delivery_date;
    this.current_expected_delivery_date = edd;
    this.edit_po_id = po.id;
    this.milestoneeditForm.controls["current_expected_delivery_date"].setValue(
      po.current_expected_delivery_date
    );
    this.current_expected_delivery_date = po.current_expected_delivery_date;
  }
  finaleditsubmission() {
    this.LoaderService.display(true);
    this.CategoryService.editOrdermain(
      this.edit_po_id,
      this.edited_date
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        // this.getItems("");
        this.purchase_orders[this.eddIndex].current_expected_delivery_date =
          res.expected_delivery_date;

        $("#editPOModal").modal("hide");
        this.successError = true;

        this.successMessage = res.message;
        setTimeout(
          function () {
            this.successError = false;
          }.bind(this),
          4000
        );
      },
      (err) => {
        this.LoaderService.display(false);
        this.msgError = true;
        this.errorMessage = JSON.parse(err["_body"]).message;
        setTimeout(
          function () {
            this.msgError = false;
          }.bind(this),
          4000
        );
      }
    );
  }

  downloadexcell() {
    if (this.final_from_date == undefined) {
      this.final_from_date = "";
    }
    if (this.final_to_date == undefined) {
      this.final_to_date = "";
    }
    if (this.searchstring == undefined) {
      this.searchstring = "";
    }
this.dateType = this.date_type
    this.CategoryService.downloadExcellmain(
      this.searchstring,
      this.final_from_date,
      this.final_to_date,
      this.dateType
    ).subscribe(
      (res) => {
        this.successError = true;
        this.successMessage =
          "You will receive the report in email once it is ready.";
        setTimeout(() => {
          this.successError = false;
        }, 4000);
      },
      (err) => {
        this.msgError = true;
        this.errorMessage = JSON.parse(err["_body"]).message;
        setTimeout(() => {
          this.msgError = false;
        }, 4000);
      }
    );
  }
  edited_date: any;
  private _trasformDateType(dateValue) {
    return moment(dateValue).format("DD/MM/yyyy");
  }
  handleInvoiceDateeditSelectEvent(event: any) {
    this.milestoneeditForm.controls["current_expected_delivery_date"].setValue(
      this._trasformDateType(event)
    );
    this.edited_date = this._trasformDateType(event);
  }

  ClearDateFilter() {
    if (this.searchstring == undefined) {
      this.searchstring = "";
    }
    if (this.current_page == undefined) {
      this.current_page = 1;
    }
    if (this.status == undefined) {
      this.status = "";
    }
    this.dateType = "";
    this.date_type = "edd";
     this.dateType = this.date_type;
    this.searchstring = "";
    this.current_page = 1;

    this.to_date = "";
    this.from_date = "";
    this.final_from_date = "";
    this.final_to_date = "";
    this.LoaderService.display(true);
    this.CategoryService.getListPObulk(
      this.searchstring,
      this.final_from_date,
      this.final_to_date,
      this.current_page,
      this.status,
      this.dateType
    ).subscribe((res) => {
      this.LoaderService.display(false);
      this.headers_res = res.headers._headers;
      this.per_page = this.headers_res.get("x-per-page");
      this.total_page = this.headers_res.get("x-total");
      this.current_page = this.headers_res.get("x-page");
      if (res.status == 204) {
        this.purchase_orders = [];
        this.podetails.total_pos = 0;
        this.podetails.total_po_amount = 0;
        this.msgError = true;
        this.errorMessage = "No Purchase orders Data Found";
        setTimeout(
          function () {
            this.msgError = false;
          }.bind(this),
          7000
        );
      }
      res = res.json();
      this.purchase_orders = res.po_wip_orders;
      this.podetails = res;
    });
  }
  expansion: any;
  searchFilter(e: any) {
    this.searchstring = e.target.value;

    if (this.final_from_date == undefined) {
      this.final_from_date = "";
    }
    if (this.final_to_date == undefined) {
      this.final_to_date = "";
    }
    if (this.status == undefined) {
      this.status = "";
    }
     this.dateType = this.date_type;

    this.current_page = 1;

    let search = e.target.value;
    this.LoaderService.display(true);
    this.CategoryService.getListPObulk(
      this.searchstring,
      this.final_from_date,
      this.final_to_date,
      this.current_page,
      this.status,
      this.dateType
    ).subscribe(
      (res) => {
        this.LoaderService.display(false);
        this.headers_res = res.headers._headers;
        this.per_page = this.headers_res.get("x-per-page");
        this.total_page = this.headers_res.get("x-total");
        this.current_page = this.headers_res.get("x-page");
        if (res.status == 204) {
          this.purchase_orders = [];
          this.podetails.total_pos = 0;
          this.podetails.total_po_amount = 0;
          this.msgError = true;
          this.errorMessage = "No Purchase orders Data Found";
          this.podetails.total_pos = 0;
          setTimeout(
            function () {
              this.msgError = false;
            }.bind(this),
            7000
          );
        }
        res = res.json();

        this.purchase_orders = res.po_wip_orders;
        this.podetails = res;
        if (this.purchase_orders.length == 0) {
          this.msgError = true;
          this.errorMessage = "No Purchase orders Data Found";
          setTimeout(
            function () {
              this.msgError = false;
            }.bind(this),
            7000
          );
        }
      },
      (err) => {
        this.LoaderService.display(false);
      }
    );
  }
  submitByDate() {
    if (this.searchstring == undefined) {
      this.searchstring = "";
    }
    if (this.status == undefined) {
      this.status = "";
    }
     this.dateType = this.date_type;

    this.current_page = 1;

    if (this.from_date !== undefined && this.from_date !== "") {
      var todayTime = this.from_date;
      var month = parseInt(("0" + (todayTime.getMonth() + 1)).slice(-2));
      var day = todayTime.getDate();
      var year = todayTime.getFullYear();
      this.final_from_date = day + "-" + month + "-" + year;
    }
    if (this.to_date !== undefined && this.to_date !== "") {
      var todayTime = this.to_date;
      var month = parseInt(("0" + (todayTime.getMonth() + 1)).slice(-2));
      var day = todayTime.getDate();
      var year = todayTime.getFullYear();
      this.final_to_date = day + "-" + month + "-" + year;
    }
    if (this.final_from_date == undefined) {
      this.final_from_date = "";
    }
    if (this.final_to_date == undefined) {
      this.final_to_date = "";
    }
    if (
      this.final_from_date == "" &&
      this.final_to_date == "" &&
      this.searchstring == ""
    ) {
      this.msgError = true;
      this.errorMessage = "Please Add Data to Search ";
      setTimeout(
        function () {
          this.msgError = false;
        }.bind(this),
        7000
      );
    } else {
      this.LoaderService.display(true);
      this.CategoryService.getListPObulk(
        this.searchstring,
        this.final_from_date,
        this.final_to_date,
        this.current_page,
        this.status,
        this.dateType
      ).subscribe(
        (res) => {
          this.LoaderService.display(false);
          this.headers_res = res.headers._headers;
          this.per_page = this.headers_res.get("x-per-page");
          this.total_page = this.headers_res.get("x-total");
          this.current_page = this.headers_res.get("x-page");
          if (res.status == 204) {
            this.purchase_orders = [];
            this.podetails.total_pos = 0;
            this.podetails.total_po_amount = 0;
            this.msgError = true;
            this.errorMessage = "No Purchase orders Data Found";
            setTimeout(
              function () {
                this.msgError = false;
              }.bind(this),
              7000
            );
          }
          res = res.json();
          this.purchase_orders = res.po_wip_orders;
          this.podetails = res;
          if (this.purchase_orders.length == 0) {
            this.msgError = true;
            this.errorMessage = "No Purchase orders Data Found";
            setTimeout(
              function () {
                this.msgError = false;
              }.bind(this),
              7000
            );
          }
        },
        (err) => {
          this.LoaderService.display(false);
        }
      );
    }
  }
  handleApproveRejectEvent(status, paymentId) {
    if (confirm(`Are you sure you want to ${status} this payment ?`) == true) {
      this.LoaderService.display(true);
      this.CategoryService.submitApproveOrRejectRequestmain(
        status,
        paymentId
      ).subscribe(
        (res) => {
          this.LoaderService.display(false);
          this.getItems("");
          this.successError = true;

          this.successMessage = `Payment request ${status} successfully !`;
          setTimeout(
            function () {
              this.successError = false;
            }.bind(this),
            4000
          );
        },
        (err) => {
          this.msgError = true;
          this.errorMessage = JSON.parse(err["_body"]).message;
          setTimeout(
            function () {
              this.msgError = false;
            }.bind(this),
            4000
          );
          this.LoaderService.display(false);
        }
      );
    }
  }
  po_preview_pdf_url_without_base_url: any;
  po_preview_pdf_url: any;
  getPOPdfForPreview(po) {
    let poid = po.id;
    this.CategoryService.getPOPdfForPreviewmain(poid).subscribe(
      (res) => {
        this.po_preview_pdf_url_without_base_url = JSON.parse(res._body).path;
        this.po_preview_pdf_url =
          environment.apiBaseUrl + JSON.parse(res._body).display_path;
        console.log(this.po_preview_pdf_url);
        if (this.po_preview_pdf_url == "" || this.po_preview_pdf_url == null) {
          this.msgError = true;
          this.errorMessage = "Pdf not found for preview!!";
          setTimeout(
            function () {
              this.erroralert = false;
            }.bind(this),
            2000
          );
          $("#poPreviewModal").modal("hide");
        }
        this.LoaderService.display(false);
      },
      (err) => {
        this.errorMessage = JSON.parse(err["_body"]).message;
        this.msgError = true;
        setTimeout(
          function () {
            this.erroralert = false;
          }.bind(this),
          13000
        );
        $("#poPreviewModal").modal("hide");
        this.LoaderService.display(false);
      }
    );
  }
  openBrowseModal() {
    $("input[id='getFile']").click();
  }
  file_name: any;
  attachment_file: any;
  basefile: any;

  onChange(event) {
    this.file_name = event.target.files[0].name;
    this.attachment_file = event.target.files[0] || event.srcElement.files[0];
    var fileReader = new FileReader();
    var base64;
    fileReader.onload = (fileLoadedEvent) => {
      base64 = fileLoadedEvent.target;
      this.basefile = base64.result;
    };
    fileReader.readAsDataURL(this.attachment_file);
  }
  purchase_order_id;
  invoice_remaining_amt;
  invoice_check;
  AddRequest(invoiceData) {
    if (this.file_name != "") {
      var obj = invoiceData;
      obj["po_wip_order_id"] = this.purchase_order_id;
      obj["attachment_file"] = this.basefile;
      obj["file_name"] = this.file_name;
      let percent_amt = (invoiceData.invoice_amount * 18) / 100;
      if (
        invoiceData.tax_amount + invoiceData.invoice_amount <=
          this.invoice_remaining_amt &&
        invoiceData.tax_amount <= percent_amt
      ) {
        this.LoaderService.display(true);
        this.CategoryService.uploadFileInmain(obj).subscribe(
          (res) => {
            $("#uploadModal").modal("hide");

            this.getItems("");

            this.successError = true;
            this.successMessage = "File Uploaded successfully";
            setTimeout(
              function () {
                this.successError = false;
              }.bind(this),
              13000
            );

            this.uploadInvoiceFormReset();

            this.invoice_check = false;
          },
          (err) => {
            this.LoaderService.display(false);
            this.msgError = true;
            this.errorMessage = JSON.parse(err["_body"])["message"];
            setTimeout(
              function () {
                this.msgError = false;
              }.bind(this),
              13000
            );
          }
        );
      } else {
        this.invoice_err_msg =
          "Sum of invoice and Tax Amt. should be less than Remaining Balance and Tax Amt. should not be more than 18% of Invoice Amt and should be less than total purchase order amount.";
      }
    } else {
      alert("First Upload A File");
    }
  }
  handleInvoiceSelectEvent(event) {
    console.log(event.target.value);
    let tax_type = event.target.value === "tax" ? true : false;
    if (tax_type) {
      this.uploadInvoiceForm.controls["tax_amount"].setValidators(
        Validators.required
      );
      this.uploadInvoiceForm.controls["tax_amount"].updateValueAndValidity();
    } else {
      this.uploadInvoiceForm.controls["tax_amount"].clearValidators();
      this.uploadInvoiceForm.controls["tax_amount"].updateValueAndValidity();
    }
    this.uploadInvoiceForm.controls["tax_invoice"].setValue(tax_type);
  }
  payment_tem_days: any;
  handleInvoiceDateSelectEvent(eventDate) {
    this.uploadInvoiceForm.controls["invoice_date"].setValue(
      this._trasformDateType(eventDate)
    );
    this.paymentTerm = new Date(eventDate);
    this.paymentTerm.setDate(eventDate.getDate() + this.payment_tem_days);
  }

  uploadInvoiceFormReset() {
    this.uploadInvoiceForm.reset();
    this.invoice_err_msg = "";
    this.invoiceType = "normal";
    this.invoice_date = "";
    this.paymentTerm = "";
    this.file_name = "";
    this.uploadInvoiceForm.controls["tax_amount"].setValue(0);
    this.uploadInvoiceForm.controls["tax_invoice"].clearValidators();
    this.uploadInvoiceForm.controls["tax_invoice"].updateValueAndValidity();
  }
  row2 = [""];
  selected_item: any;
  openPanel(rowId) {
    if (this.row2[0] !== rowId) {
      this.selected_item = rowId;
      this.row2[0] = rowId;
    } else {
      this.row2[0] = "";
      this.selected_item = "";
    }
  }

  row3 = [""];
  selected_item2: any;
  openPanel2(rowId) {
    if (this.row3[0] !== rowId) {
      this.selected_item2 = rowId;
      this.row3[0] = rowId;
    } else {
      this.row3[0] = "";
      this.selected_item2 = "";
    }
  }

  selectedInvoice;
  raiseRequest(selectedInvoceId) {
    this.selectedInvoice = selectedInvoceId;
  }
  cancelRequest() {
    this.selectedInvoice = "";
  }
  submitRequest(invoiceFileId, remainingpayment) {
    console.log(remainingpayment);
    let enteredAmt = (<HTMLInputElement>(
      document.getElementById(`amt-${invoiceFileId}`)
    )).value;
    if (enteredAmt) {
      if (parseInt(enteredAmt) <= parseInt(remainingpayment)) {
        this.CategoryService.submitRaiseRequestForInvoicemain(
          this.purchase_order_id,
          invoiceFileId,
          enteredAmt
        ).subscribe(
          (res) => {
            this.selectedInvoice = "";
            this.getItems("");
            this.successError = true;
            this.successMessage = "Request Raised Successfully";
            setTimeout(
              function () {
                this.successError = false;
              }.bind(this),
              13000
            );
          },
          (err) => {
            this.msgError = true;
            this.errorMessage = JSON.parse(err["_body"])["message"];
            setTimeout(
              function () {
                this.msgError = false;
              }.bind(this),
              13000
            );
          }
        );
      } else {
        this.msgError = true;
        this.errorMessage =
          "Entered amount should be less than equal to the remaining amount!";
        setTimeout(
          function () {
            this.msgError = false;
          }.bind(this),
          13000
        );
      }
    } else {
      this.msgError = true;
      this.errorMessage = "Please enter Amount first";
      setTimeout(
        function () {
          this.msgError = false;
        }.bind(this),
        13000
      );
    }
  }
  handleCloseEvent() {}
  handleNegativeValue(event, invoiceFileId) {
    if (event.target.value < 0) {
      this.msgError = true;
      this.errorMessage = "You cannot enter negative value";
      setTimeout(
        function () {
          this.erroralert = false;
        }.bind(this),
        13000
      );
      (<HTMLInputElement>(
        document.getElementById(`amt-${invoiceFileId}`)
      )).value = "0";
    }
  }

  deleteinvloice(id, po) {
    if (confirm("Are you sure to delete invoice") == true) {
      this.CategoryService.DeleteInvoicemain(id).subscribe(
        (res) => {
          this.successError = true;

          this.successMessage = "Deleted Successfully";
          this.getItems("");

          setTimeout(
            function () {
              this.successError = false;
            }.bind(this),
            13000
          );
        },
        (err) => {
          this.msgError = true;
          this.errorMessage = JSON.parse(err["_body"])["message"];
          setTimeout(
            function () {
              this.msgError = false;
            }.bind(this),
            13000
          );
        }
      );
    }
  }
  status: any;
  filterStatus(e) {
    this.status = e.target.value;

    this.getItems("");
  }
  date_type :any;
  changeDateType(value) {
    this.date_type = value;
    this.from_date ='';
    this.to_date ='';
  }
}



// WEBPACK FOOTER //
// ./src/app/platform/category/category/bulk-po/bulk-po.component.ts